// import Vue from 'vue'
import KHweixin from './weixinData'
import { serviceO as axiosIns } from '../utils/axios'

// import KHbase from '@/kanghe.config'
window.weixinShareFunction = function(){
    // 微信分享
    // if(Vue.wxShareFlag){
    //     return ;
    // }
    var data = {
        appId:KHweixin.appid,
        url:window.location.origin+"/"+window.location.search
    }
    axiosIns({url:"/weixinAuthApi/generateSignature",data,method:"post"}).then(res=>{
        if(res.success){
            // Vue.prototype.wxShareFlag = true; 
            res = res.content;
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId:KHweixin.appid, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.noncestr, // 必填，生成签名的随机串
                signature: res.signature,// 必填，签名
                jsApiList: [
                "chooseWXPay",
                'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'hideMenuItems',
                'showMenuItems',
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
            ] // 必填，需要使用的JS接口列表
            });
            wx.ready(function(){
                window.weixinShareFlag = true;
                wx.hideMenuItems({
                    menuList: ["menuItem:copyUrl"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                });
            })
        }
    })
}
// window.weixinShareFunction();
var wxShare = {
    share(obj){
        var {url,imgUrl,title,desc} = obj
        function init(){
            wx.onMenuShareAppMessage({
                title: title,
                desc: desc,
                link: url,
                imgUrl: imgUrl,
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '',
            });
            // 
            wx.updateAppMessageShareData({
                title: title,
                desc: desc,
                link: url,
                imgUrl: imgUrl
            });
            wx.updateTimelineShareData({ 
                title: title, // 分享标题
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: '' // 分享图标
            })
            wx.onMenuShareQQ({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接
                imgUrl: imgUrl // 分享图标
            });
        }
        init()
    },
    hide(){
        // function hideMenuItem(){
        wx.hideMenuItems({
            menuList: ["menuItem:share:appMessage", "menuItem:share:timeline","menuItem:share:qq", "menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        });
        // }
        // hideMenuItem()        
    },
    show(){
        wx.showMenuItems({
            menuList: ["menuItem:share:appMessage", "menuItem:share:timeline","menuItem:share:qq", "menuItem:share:weiboApp","menuItem:copyUrl"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        });
    }
}
export default wxShare


// WEBPACK FOOTER //
// ./src/wx/wxShare.js